export enum RequestStatuses {
  fulfilled = 'fulfilled',
  rejected = 'rejected'
}
